export default typeof window !== 'undefined' && window['scion'] && window['scion']['scxml'] ? window['scion']['scxml'] : require('@scion-scxml/scxml');
